
import React from 'react';
import Layout from '@/components/layout/Layout';
import RegionalMarketingRecommendations from '@/components/marketing/RegionalMarketingRecommendations';

const RegionalMarketing: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl mx-auto px-4 py-8">
        <RegionalMarketingRecommendations />
      </div>
    </Layout>
  );
};

export default RegionalMarketing;
